export function uninstallServiceWorker() {
  navigator.serviceWorker.register("/sw.js").then(() => {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        registration.unregister();
      }
    });
  });
}
